(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beovita-anwendung"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      (root||document).querySelectorAll('.bv-anw').forEach(function(el){
        if(el.dataset.bound) return; el.dataset.bound='1';
        var steps = el.querySelectorAll('.bv-anw__step');
        var shots = el.querySelectorAll('.bv-anw__shot');
        if(!steps.length || !shots.length) return;
        function setActive(i){ steps.forEach(function(s,idx){ s.classList.toggle('is-active', idx===i); }); }
        if(!('IntersectionObserver' in window)){ return; }
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){ setActive(parseInt(e.target.getAttribute('data-i'),10) || 0); }
          });
        }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
        shots.forEach(function(s){ io.observe(s); });
      });
    }
    document.addEventListener('DOMContentLoaded', function(){ init(); });
    init();
    document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beovita-dhdl"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function play(m){ var url=m.getAttribute('data-video'); if(!url) return; var yt=m.getAttribute('data-yt'); var el;
      if(yt){ el=document.createElement('iframe'); el.src='https://www.youtube.com/embed/'+yt+'?autoplay=1&rel=0'; el.setAttribute('allow','autoplay; encrypted-media; picture-in-picture'); el.setAttribute('allowfullscreen',''); }
      else { el=document.createElement('video'); el.src=url; el.controls=true; el.autoplay=true; el.setAttribute('playsinline',''); }
      el.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0;background:#000;object-fit:cover;'; m.innerHTML=''; m.appendChild(el); }
    function startbg(v){ if(v.dataset.bgStarted) return; var src=v.getAttribute('data-bg-src'); if(!src) return; v.dataset.bgStarted='1';
      var s=document.createElement('source'); s.src=src; s.type='video/mp4'; v.appendChild(s);
      v.muted=true; v.setAttribute('muted',''); v.load();
      var p=v.play(); if(p&&p.catch){ p.catch(function(){ /* retry once on interaction */ document.addEventListener('pointerdown',function once(){ v.play().catch(function(){}); document.removeEventListener('pointerdown',once); }, {once:true}); }); } }
    function playbg(root){ var vids=(root||document).querySelectorAll('.bv-dhdl__video');
      if(!('IntersectionObserver' in window)){ vids.forEach(startbg); return; }
      var io=new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ startbg(en.target); io.unobserve(en.target); } }); }, { rootMargin:'400px 0px' });
      vids.forEach(function(v){ io.observe(v); }); }
    function boot(root){ (root||document).querySelectorAll('.bv-dhdl__play').forEach(function(btn){ if(btn.dataset.b) return; btn.dataset.b='1'; btn.addEventListener('click',function(){ play(btn.closest('.bv-dhdl__media')); }); }); playbg(root); }
    document.addEventListener('DOMContentLoaded',function(){boot();}); boot();
    document.addEventListener('shopify:section:load',function(e){boot(e.target);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beovita-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function start(v){
      if(v.dataset.heroStarted) return;
      var src = v.getAttribute('data-hero-src'); if(!src) return;
      v.dataset.heroStarted = '1';
      var s = document.createElement('source'); s.src = src; s.type = 'video/mp4'; v.appendChild(s);
      v.muted = true; v.setAttribute('muted','');
      v.load();
      var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
    }
    function boot(root){
      // Nicht bei Reduced-Motion und nicht auf kleinen Screens (dort nur Poster)
      if(window.matchMedia){
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if(!window.matchMedia('(min-width:750px)').matches) return;
      }
      (root||document).querySelectorAll('.bv-hero__video').forEach(start);
    }
    var scheduled = false;
    function schedule(){
      if(scheduled) return; scheduled = true;
      if('requestIdleCallback' in window){ requestIdleCallback(function(){ boot(); }, { timeout: 2500 }); }
      else { setTimeout(function(){ boot(); }, 300); }
    }
    // Kurz nach DOM-ready (idle-gated) ODER spätestens window.load – was zuerst kommt.
    // So hängt das Video NICHT an der langsamen Third-Party-Last (window.load),
    // blockiert aber auch nicht das First Paint.
    function armSoon(){ setTimeout(schedule, 1400); }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', armSoon); }
    else { armSoon(); }
    window.addEventListener('load', schedule);
    // Im Theme-Editor sofort zeigen
    document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beovita-ugc"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function boot(root){
      (root||document).querySelectorAll('.bv-ugc__vid').forEach(function(v){
        v.muted=true; var p=v.play(); if(p&&p.catch){ p.catch(function(){}); }
      });
    }
    document.addEventListener('DOMContentLoaded',function(){boot();}); boot();
    document.addEventListener('shopify:section:load',function(e){boot(e.target);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beovita-zahnarzt"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function boot(root){ (root||document).querySelectorAll('.bv-arzt__video').forEach(function(v){ v.muted=true; v.setAttribute('muted',''); var p=v.play(); if(p&&p.catch){ p.catch(function(){}); } }); }
    document.addEventListener('DOMContentLoaded',function(){boot();}); boot();
    document.addEventListener('shopify:section:load',function(e){boot(e.target);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-kuendigung"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var form = document.getElementById('bv-kue-form');
    if(!form) return;

    function wireToggle(radioSel, boxSel){
      var box = form.querySelector(boxSel);
      if(!box) return;
      form.querySelectorAll('input[type="radio"]').forEach(function(r){
        r.addEventListener('change', function(){
          var on = form.querySelector(radioSel) && form.querySelector(radioSel).checked;
          box.hidden = !on;
        });
      });
    }
    wireToggle('input[data-ausser]', '.bv-kue__grund');
    wireToggle('input[data-date]', '.bv-kue__datum');

    function val(name){ var el = form.querySelector('[name="'+name+'"]'); return el ? el.value.trim() : ''; }
    function radioVal(name){ var el = form.querySelector('[name="'+name+'"]:checked'); return el ? el.value : ''; }

    // Fire Klaviyo BEFORE the native submit proceeds (no preventDefault → Shopify handles hCaptcha + mail).
    form.addEventListener('submit', function(){
      if(!form.checkValidity()) return; // invalid → browser blocks submit, don't fire event

      var now = new Date();
      var tsHuman = now.toLocaleString('de-DE', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) + ' Uhr';
      var d = {
        email: val('contact[email]'), vorname: val('contact[Vorname]'), nachname: val('contact[Nachname]'),
        kennung: val('contact[Vertragskennung]'), bezeichnung: val('contact[Vertragsbezeichnung]'),
        art: radioVal('contact[Kuendigungsart]'), grund: val('contact[Grund]'),
        zeitpunkt: radioVal('contact[Kuendigungszeitpunkt]'), datum: val('contact[Beendigungsdatum]'),
        anschrift: val('contact[Anschrift]')
      };

      var bodyEl = document.getElementById('bv-kue-body');
      if(bodyEl){
        bodyEl.value =
          'KÜNDIGUNG (Kündigungsbutton §312k) – Eingang: ' + tsHuman + '\n' +
          'Vertrags-/Abo-/Bestellnr.: ' + d.kennung + '\n' +
          'Bezeichnung: ' + d.bezeichnung + '\n' +
          'Art: ' + d.art + (d.grund ? ' | Grund: ' + d.grund : '') + '\n' +
          'Zeitpunkt: ' + d.zeitpunkt + (d.datum ? ' (' + d.datum + ')' : '') + '\n' +
          'Name: ' + d.vorname + ' ' + d.nachname + '\n' +
          'E-Mail: ' + d.email + '\n' +
          'Anschrift: ' + d.anschrift;
      }

      try{
        var ident = { '$email': d.email, '$first_name': d.vorname, '$last_name': d.nachname };
        var props = {
          'Vertragskennung': d.kennung, 'Vertragsbezeichnung': d.bezeichnung,
          'Kuendigungsart': d.art, 'Grund': d.grund,
          'Kuendigungszeitpunkt': d.zeitpunkt, 'Beendigungsdatum': d.datum,
          'Anschrift': d.anschrift, 'Name': d.vorname + ' ' + d.nachname,
          'Eingang_ISO': now.toISOString(), 'Eingang_lesbar': tsHuman
        };
        if(window._learnq){ window._learnq.push(['identify', ident]); window._learnq.push(['track', 'Kündigung eingegangen', props]); }
        else if(window.klaviyo && window.klaviyo.identify){ window.klaviyo.identify({email:d.email, first_name:d.vorname, last_name:d.nachname}); window.klaviyo.track('Kündigung eingegangen', props); }
      }catch(e){}
      // kein preventDefault → natives Submit (Shopify hCaptcha + Händler-Mail + Redirect zur Bestätigung)
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
